import React from "react"

const NetdataLogo = () => (
  <svg width="114" height="22" viewBox="0 0 114 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.6585 5.5H31.3601L36.7328 14.0221V5.5H38.1013V16.0202H36.4866L31.0343 7.50521V16.0202H29.6585V5.5ZM43.4712 5.5H51.2261V6.78906H44.8759V9.98307H50.7482V11.2005H44.8759V14.7669H51.3347V16.0202H43.4712V5.5ZM63.9309 6.75326V5.5H55.2998V6.75326H58.8841V16.0202H60.3467V6.75326H63.9309ZM72.2984 14.8027C72.786 14.8027 73.1866 14.7526 73.5004 14.6523C74.0604 14.4661 74.5189 14.1081 74.8762 13.5781C75.161 13.1532 75.3661 12.6089 75.4916 11.9453C75.564 11.549 75.6003 11.1814 75.6003 10.8424C75.6003 9.53906 75.3384 8.52691 74.8146 7.80599C74.2909 7.08507 73.4473 6.72461 72.2839 6.72461H69.7279V14.8027H72.2984ZM68.2798 5.5H72.5881C74.0507 5.5 75.1851 6.01323 75.9913 7.03971C76.7105 7.96593 77.0701 9.15234 77.0701 10.599C77.0701 11.7162 76.8577 12.7259 76.4329 13.6283C75.6847 15.2229 74.3983 16.0202 72.5736 16.0202H68.2798V5.5ZM85.7346 7.0612L87.3493 11.709H84.0185L85.7346 7.0612ZM86.6107 5.5H84.9815L80.9773 16.0202H82.4545L83.6058 12.8691H87.8127L88.8916 16.0202H90.4701L86.6107 5.5ZM101.394 5.5V6.75326H97.8094V16.0202H96.3468V6.75326H92.7626V5.5H101.394ZM108.429 7.0612L110.044 11.709H106.713L108.429 7.0612ZM109.305 5.5H107.676L103.672 16.0202H105.149L106.3 12.8691H110.507L111.586 16.0202H113.164L109.305 5.5Z"
        fill="#35414A"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6829 20.1667H9.19572L0 2.75H13.0531C18.1287 2.75915 22.2412 6.79519 22.2439 11.7742C22.2357 16.4142 18.4068 20.1667 13.6829 20.1667Z"
      fill="#68C47D"
    />
    <defs>
      <clipPath id="clip0">
        <rect width="84.3415" height="11" fill="white" transform="translate(29.6585 5.5)" />
      </clipPath>
    </defs>
  </svg>
)

export default NetdataLogo
